export const parseGestionAmount = value => {
  if (value == null) return 0
  const direct = Number(value)
  if (Number.isFinite(direct)) return direct
  const sanitized = String(value).replace(/\s+/g, '').replace(/\./g, '').replace(',', '.')
  const fallback = Number(sanitized)
  return Number.isFinite(fallback) ? fallback : 0
}

// Listado y detalle deben aplicar el mismo criterio contable.
export const getGestionMovementAmounts = movement => {
  const status = String(movement?.libro?.status ?? movement?.status ?? 'PENDIENTE').toUpperCase()
  const amount = parseGestionAmount(movement?.montoTotal ?? movement?.pagado)
  if (status.includes('ANULA')) return { totalFacturado: 0, saldoPorCobrar: 0 }
  return {
    totalFacturado: amount,
    saldoPorCobrar: ['COBRADO', 'PAGADO'].includes(status) ? 0 : amount
  }
}
